<template>
  <div>
    <!-- <div style="height: 300px"></div> -->
    <div style="display: flex; justify-content: center">
      <div
        style="
          width: 60%;
          display: flex;
          justify-content: space-around;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <div>
          <div>
            {{ $t("accessoriyList.品牌") }}
            <a-select
              mode="multiple"
              :default-value="[]"
              style="width: 200px; margin-left: 10px"
              :placeholder="$t('accessoriyList.请选择')"
              @change="brandChange"
            >
              <a-select-option v-for="(item, index) in brandList" :key="index">
                {{ item }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div>
          <InputLikeSelect
            stockpile="inputLikeSelect"
            @InputLikeSelect="InputLikeSelect"
            :columnsResult="columns"
          />
        </div>
      </div>
    </div>
    <!-- <div
      style="
        display: flex;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 20px;
      "
    >
      <a-button type="link" size="large">{{ $t("叉车属具.条件重置") }}</a-button
      ><a-button type="primary" size="large" icon="search">
        {{ $t("叉车属具.搜索") }}</a-button
      >
    </div> -->
    <div style="display: flex; justify-content: center">
      <div style="width: 82%; padding: 30px">
        <a-spin tip="Loading..." :spinning="loading">
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-evenly;
            "
          >
            <accessoriy-mode
              v-for="(item, index) in list"
              :key="index"
              :record="item"
              class="right mode-background"
            >
            </accessoriy-mode>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import AccessoriyMode from "../model/accessoriyMode.vue";
import axios from "axios";
import InputLikeSelect from "../model/InputLikeSelect.vue";
import { columns } from "./accessoriyList";

export default {
  components: { AccessoriyMode, InputLikeSelect },
  data() {
    return {
      columns,
      list: [],
      loading: false,
      brandList: [],
      mainOptions: {
        actionName: "getAssetReport",
        filters: {
          queryFilter: [
            {
              dataIndex: "type",
              operator: "eq",
              value: "叉车属具",
            },
            {
              dataIndex: "stateMsg",
              operator: "eq",
              value: "在库",
            },
          ],
        },
        orderBy: [
          {
            field: "reportTime",
            order: "desc",
          },
          {
            field: "model",
            order: "asc",
          },
          {
            field: "code",
            order: "asc",
          },
        ],
        offset: 0,
        limit: 12,
      },
    };
  },
  created() {
    // 创建防抖函数，延迟500毫秒执行
    this.debouncedQueryAction = this.debounce(this.queryAction, 500);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.debouncedQueryAction();
    this.queryBrand();
    window.scrollTo({
      top: 0,
      behavior: "instant", // 可选，设置为 'smooth' 可以平滑滚动
    });
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 模糊查询，传入用户输入的数据
    InputLikeSelect(ev) {
      if (ev === "" || ev === "{}" || ev.length === 0) {
        delete this.mainOptions.filters.x_InputLikeSelect;
      } else {
        this.mainOptions.filters.x_InputLikeSelect = ev;
      }
      this.mainOptions.offset = 0; // 从第一行开始
      this.queryAction();
    },
    brandChange(e) {
      console.log(e);
      if (e.length > 0) {
        this.mainOptions.filters.x_brandFillter = e.map((item) => {
          return {
            dataIndex: "brand",
            operator: "eq",
            value: this.brandList[item],
          };
        });
      } else {
        delete this.mainOptions.filters.x_brandFillter;
      }
      this.queryAction();
    },
    //查询车辆品牌
    queryBrand() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "4",
        },
      }).then((res) => {
        this.brandList = res.data.data.optionArr.split(",");
      });
    },
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this,
          args = arguments;
        let later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    handleScroll() {
      // 处理滚动事件
      //console.log(window.scrollY); // 输出当前滚动位置
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      if (scrollTop + clientHeight >= scrollHeight) {
        this.mainOptions.offset = this.list.length;
        this.debouncedQueryAction(true);
      }
    },
    queryAction(append) {
      this.loading = true;
      axios
        .post(this.$apiUrl + "/api/general/queryAction", this.mainOptions)
        .then((res) => {
          console.log(res);
          this.loading = false;
          let temp = res.data.data.map((item) => {
            item.assetConfig.split(";").forEach((obj) => {
              const e = obj.split(":");
              item[e[0]] = e[1];
            });
            return {
              ...item,
            };
          });
          if (append) {
            this.list = this.list.concat(temp);
          } else {
            this.list = temp;
          }
        });
    },
  },
};
</script>

<style scoped>
.mode-background {
  position: relative;
  width: 350px;
}
.mode-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1; /* 将伪元素置于内容下方 */
  padding: 50px; /* 与内边距相同，确保阴影从内容区域开始 */

  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.19); /* 添加阴影 */
}
.right {
  /* 添加过渡效果，这样阴影和放大都能有动画 */
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.right:hover {
  /* 悬停时放大 */
  transform: scale(1.05);
  /* 悬停时改变阴影效果，使其更明显 */
  /* box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.3); */
}
</style>
